<template>
  <el-card shadow="never" class="steps-card" v-if="personNum.length">
    <el-steps :active="active">
      <el-step :space="16" v-for="(item, i) in personNum" :key="i" :title="'拉新'+item+'人'">
        <i :class="i<active?'step01':'step02'" slot="icon"></i>
      </el-step>
    </el-steps>
    <div class="msg-box">
      <span class="msg">{{activityMessage}}</span>
      <el-button v-if="!expressNumber" plain @click="receivingInfo">修改收货信息</el-button>
    </div>
    <ReceivingInfo ref="receivingInfo" />
  </el-card>
</template>
<script>
import ReceivingInfo from './receivingInfo.vue'
export default {
  components: { ReceivingInfo },
  props:['expressNumber'],
  data() {
    return {
      applyId: '',
      active: 1,
      personNum:[],
      activityMessage:'',
      pullNewTotal:0
    }
  },
  methods: {
    init (param) {
      const { activityMessage, personNum, pullNewTotal, applyId } = param
      this.personNum = personNum
      this.activityMessage = activityMessage
      this.pullNewTotal = pullNewTotal
      this.applyId = applyId
      this.active = 0
      for (let i in personNum) {
        if(personNum[i] <= pullNewTotal){
          this.active++
        }
      }
    },
    receivingInfo () {
      console.log('修改地址')
      this.$refs.receivingInfo.init(this.applyId)
    }
  }
}
</script>
<style lang="less" scoped>
.steps-card {
  overflow: auto;
  /deep/.el-card__body {
    min-width: 964px;
  }
}
/deep/.el-step__line {
  background-color: #EBF2FF;
}
/deep/.el-step__icon.is-text {
  border: none;
  width: 16px;
}
/deep/.el-step__head.is-finish{
  color: #3377FF;
  border-color: #3377FF;
}
/deep/.el-step__title.is-wait, /deep/.el-step__title.is-process {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}
/deep/.el-step__title.is-finish {
  color: #3377FF;
  font-size: 12px;
  font-weight: 700;
}
/deep/.el-step  {
  max-width: 300px;
}
.step01{
  background: url('../../../../assets/image/icon/steps-active.png');
  width: 16px;
  height: 16px;
}
.step02{
  background: url('../../../../assets/image/icon/steps.png');
  width: 16px;
  height: 16px;
}
.msg-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
.msg{
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  margin-right: 16px;
}
</style>